import { makeStyles, withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import SearchIcon from "@material-ui/icons/Search";
import React, { useEffect, useState } from "react";
import { getSubmissions, updateStatus } from "../apis/submissionsitems";

import DesignIcon from '@material-ui/icons/ThumbUp';
import NotFeasibleIcon from '@material-ui/icons/ThumbDown';
import NotesIcon from '@material-ui/icons/Notes';
import ViewIcon from '@material-ui/icons/Visibility';
import Tooltip from "@material-ui/core/Tooltip";

// import {apiGet, apiPost} from "../apis/apiUtils"
import {LightTooltip} from "./LightTooltip";
import useStyles from "./muistyles";

import {updateSubmission} from "../apis/submissionsitems";
import "./GenericReusableComponents/table.css"
import {Table} from "./GenericReusableComponents/Table"



import Loading from "./Loading";

export default function Submissions(props) {
  const [processItems, setProcessReports] = useState([]);
  const [filteredProcessReports, setFilteredProcessReports] = useState([]);
  const [q, setQ] = useState("");
  const [showAddProcessReportForm,setShowAddProcessReportForm] = useState(false);
  const [showDelProcessReportModal,setShowDelProcessReportModal] = useState(false);
  const [taskTobeDel,setProcessReportTobeDel] = useState({});
  const [taskTobeUpdt,setProcessReportTobeUpdt] = useState({});
  const [showUpdtProcessReportModal,setShowUpdtProcessReportModal] = useState(false);
  const[updated, setUpdated] = useState(false);
  const classes = useStyles();

  const [loading, setLoading] = useState(true)




  useEffect(() => {
    console.log("Inside useEffect Submissions")
    let mounted = true;

    getSubmissions(props.processId).then((processItems) => {
      console.log("display Submissions");
      // console.log(processItems.data);
      

      if (mounted) {
        setProcessReports(processItems.data);
        var fprocessItems = [];
        processItems.data.forEach((x) => fprocessItems.push(x));
        setFilteredProcessReports(fprocessItems);
        setUpdated(false);
        setLoading(false);
      }

    });

    return () => {console.log("Submissions is unmounted"); mounted = false};
  }, [updated]);

  function filterTable(filterString) {
    console.log(filterString);
    let trimStr = filterString.trim();
    if (trimStr === "") {
      setFilteredProcessReports(processItems);
      setQ("");
    } else {
      setQ(filterString);
      setFilteredProcessReports(
        processItems.filter((task) => {
          if (task.taskName.startsWith(filterString)) return true;


          if (task.userName.startsWith(filterString)) return true;


          if (task.status.startsWith(filterString)) return true;

          console.log("no match ");
          console.dir(task);
        })
      );
    }
  }

  


  function approved(e, processItem){
    updateSubmissionStatus(processItem.submissionId, "Approved")
    processItem.status = 'Approved'

  }

  function rejected(e, processItem){
    updateSubmissionStatus(processItem.submissionId, "Rejected")
    processItem.status = 'Rejected'
  }


  function updateSubmissionStatus(id, status){
    updateSubmission(id,status)
    .then((response)=>{
      if(response.ok){
        console.log("Updated "+updated);
        setUpdated(true);
      }else{
        alert("response from updateSubmission failed");
      }
    })
    .catch((err)=>alert(err));
  }

  function notes(e, processItem){
    
  }

  function view(e, processItem){
    const submissionId = processItem.submissionId
    var url = `${process.env.REACT_APP_API_PREFIX}/storagemanagement/generateDownloadPresignedUrlListBySubmissionId/` ;
    // const body = {submissionId: submissionId}
    // console.log(body)
    // // const urls = apiPost(url, body )
    // var urls
    // var requestOptions = {
    //   method: 'POST',
    //   body:JSON.stringify(body)
    //   // headers: { 'Content-Type': 'application/json'}
    // }

    // fetch(url , requestOptions)
    // .then (async response => {
    //   const data = await response.text();
    //   // console.log(data)
    //   if (!response.ok) 
    //   {
    //     const error = (data && data.message) || response.status;
    //     console.log(error)
    //     return Promise.reject(error);

    //   }
    //   urls = JSON.parse(data)
    //   if (urls.result == "failure") { alert("Nothing submited"); return }
      
    //   console.log(urls)
    //   var list = urls.data.preSignedUrList

    //   for (var index = 0; index < list.length; index ++ ){
    //     var fileName = list[index].fileName
    //     var downloadURL = list[index].url
    //     var contentType = list[index].contentType
    //     // console.log("download..." + downloadURL)

    //     const options = {
    //       method: 'GET',
    //       // headers: { 'Content-Type': contentType}
    //     }
    
    //     fetch(downloadURL, options)
    //     .then (async response => {
    //       const data = await response.text();
    //       if (!response.ok) 
    //       {
    //         const error = (data && data.message) || response.status;
    //         console.log(error)
    //         return Promise.reject(error);
    
    //       }
    //       // console.log("Got response:" + data)
    //     })
  
    //     .catch(error => {alert(error)});
    
    //   }
  


    // })

    // .catch(error => {alert(error)});


    props.onSubmissionIdChange(submissionId, processItem.taskName)
    props.setTabIndex(4)
  }


  function setShow(bool){
    setShowAddProcessReportForm(bool);
  }

  function setShowDel(bool){
    setShowDelProcessReportModal(bool);
  }

  function setShowUpdt(bool){
    setShowUpdtProcessReportModal(bool);
  }
  //temporarily duplicating the code. reuse later
  function getStatusStyle(status){
    var statusStyle = "status";
    switch (status){
      case "INACTIVE":
        statusStyle = statusStyle + " statusInactive";
        break;
      case "DISABLED":
        statusStyle = statusStyle + " statusDisabled";
        break;

      default: statusStyle = statusStyle + " statusActive"
    }
    return statusStyle;
  }

  function getTableBody(){
    console.log(filteredProcessReports)
    return(
      <>
           {filteredProcessReports.map((processItem) => (
            <tr>
              <td>{processItem.taskName}</td>
              <td width="300px">{processItem.submissionDate === undefined? "":new Date(processItem.submissionDate).toLocaleString("en-US")}</td>
              <td>{processItem.userName}</td>
              <td>{processItem.timeTaken}</td>
              <td>{processItem.frequency}</td>
              <td><span className={getStatusStyle(processItem.status)}>{processItem.status}</span></td>
              {/* <td>{processItem.status}</td> */}
              <td> 
                <div className='tableActions'>
                <LightTooltip title={"View Submission Details"}>
              {/* <IconButton style={(processItem.status == 'Open')? {display: 'none'}:{}} onClick={(e)=>view(e,processItem)}> */}
              <IconButton className="toolbutton" disabled={(processItem.status == 'Open')? true:false} onClick={(e)=>view(e,processItem)}>
                  <ViewIcon className ='roundButton' ></ViewIcon>
                </IconButton>
                </LightTooltip>

                <LightTooltip title={"Notes"}>
                <IconButton className="toolbutton" disabled={(processItem.status == 'Open')? true:false}  onClick={(e)=>notes(e,processItem)}>
                  <NotesIcon className ='roundButton'></NotesIcon>
                </IconButton>
                </LightTooltip>

                <LightTooltip title={"Approve"}>
                <IconButton className="toolbutton" disabled={(processItem.status == 'Open' || processItem.status=='Approved')? true:false}  onClick={(e)=>approved(e,processItem)}>
                  <DesignIcon className ='roundButton' ></DesignIcon>
                </IconButton>
                </LightTooltip>

                <LightTooltip title={"Reject"}>
                <IconButton className="toolbutton" disabled={(processItem.status == 'Open' || processItem.status=='Rejected')? true:false}  onClick={(e)=>rejected(e,processItem)}>
                  <NotFeasibleIcon className ='roundButton' ></NotFeasibleIcon>
                </IconButton>
                </LightTooltip>
              </div>
              </td>
            </tr>
          ))}
      </>

    )
  }

  function getTableHeader(){
    return(
      <>
          <tr>
           <LightTooltip title="Task Name associated with Submission"> 
             <th>Task Name</th>
             </LightTooltip>
             {/* <th>Description</th> */}
             <LightTooltip title="Date Submission was made"> 
             <th>Submission Date</th>
             </LightTooltip>
             <LightTooltip title="User who made the submission"> 
             <th>User</th>
             </LightTooltip>
             <LightTooltip title="Duration of recording"> 
             <th>Time Taken</th>
             </LightTooltip>
             <LightTooltip title="Number of times task is done per day"> 
             <th>Frequency</th>
             </LightTooltip>

            <LightTooltip title="Status of submission"> 
             <th>Status</th>
             </LightTooltip>

             <LightTooltip title="View, Make Notes, Approve/Reject Submissions"> 
             <th>Actions</th>
             </LightTooltip>
         </tr>

      </>

    )

  }

  return (
    <>
      {/* <p/>
      <label style={{padding:'5px', backgroundColor:'#bababa', color:'white', fontSize:'18px'}}>{props.processName}</label>
      <p/> */}
      <Table
        search={filterTable}
        columns={getTableHeader()} 
        rows={getTableBody()}
        loading={loading}
        tbcontainerstyle={{margin:'0px',padding:'0px'}}
      />
    </>
  );
}
